/**
 *
 * @/services/endpoints/session.js
 *
 */

//
// IMPORTS
//

import store from '@/store'
import { testFbAuth } from "@/services"
import { httpPost, httpGet } from "@/services/api/http"
import { version, PARTNER } from '@/constants'

//
// USER SESSION API FUNCTIONS
//

export const getSessionToken = async () => {
  const user = (testFbAuth ?? {})?.currentUser || null
  try {
    return user ? await user.getIdToken() /* usuário logado */ : null /* usuário não logado */
  } catch {
    return null
  }
}

// --- User e-mail
export const apiGetUserEmail = () => String((testFbAuth ?? {})?.currentUser?.email || "")

// --- User ID
export const getUserID = () => String((testFbAuth ?? {})?.currentUser?.uid || "")

export const getUserUID = () => store.state?.app?.userSession?.uid || getUserID()

// --- Login: validate in Laravel and start Firebase session with a Custom Token
export const apiUserLogin = async (device, email, password) => {
  // Ask Laravel to validate credentials and return a Custom Token
  const request = await httpPost({ route: "api/v1/users/login", fields: { device, email, password }, headers: { "Client": "WEB", "X-Partner": PARTNER, "X-App-Version": version } })
  if (request.httpCode !== 200) return request
  // Sign in to Firebase using the Custom Token
  try {
    const cred = await testFbAuth.signInWithCustomToken(request.data.customToken)
    return { httpCode: 200, code: 1, title: "Feito!", message: cred, data: { target: "" } }
  } catch (e) {
    const code = String(e?.code || "").trim()
    const message = e?.message || "Erro desconhecido"
    // Common errors: auth/invalid-custom-token, auth/custom-token-mismatch, auth/network-request-failed
    return { httpCode: 500, title: "Atenção!", message: `${message}${code ? ` (Código: ${code})` : ""}`, data: { target: ""/* , error_code: code */ } }
  }
}

// --- Send password reset email via backend
export const apiRequestPasswordReset = email => httpPost({ route: "api/v1/users/password-reset", fields: { email }, headers: { "Client": "WEB", "X-Partner": PARTNER, "X-App-Version": version } })

// --- Atualiza sessão do usuário no backend
export const apiPing = (token, email, device) => httpPost({ route: `api/v1/users/${getUserID() || "userID"}/ping`, fields: { token, email, device }, headers: { "Client": "WEB", "X-Partner": PARTNER, "X-App-Version": version, "User-ID": getUserID() /* viewerID */ } })

// --- Verify password reset token and set new passwords, via token
export const apiVerifyPasswordResetToken = token => httpGet({ route: `api/v1/users/password-reset/${token}/verify`, headers: { "Client": "WEB", "X-Partner": PARTNER, "X-App-Version": version } })

// --- Verify password reset token and set new passwords, via token
export const apiSetNewPassword = (token, newPassword) => httpPost({ route: `api/v1/users/password-reset/${token}/set`, fields: { newPassword }, headers: { "Client": "WEB", "X-Partner": PARTNER, "X-App-Version": version } })
